
export const ADMIN = "ADMIN";
export const PARTNER = "PARTNER";
export const SUPER_ADMIN = "SUPER_ADMIN";